import PropTypes from "prop-types";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Controlled shadcn confirmation dialog for a general action. The caller owns
 * the open state and provides `onConfirm`; Cancel, Escape, and a backdrop click
 * close through `onOpenChange`, so a caller that needs to know a cancel should
 * read it there. See ConfirmDeleteDialog for the destructive-delete variant.
 */
const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "Are you sure?",
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant,
  cancelVariant = "outline",
  icon,
  onConfirm,
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent size="sm">
      <AlertDialogHeader>
        {icon && <AlertDialogMedia>{icon}</AlertDialogMedia>}
        <AlertDialogTitle as="span">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel variant={cancelVariant}>
          {cancelText}
        </AlertDialogCancel>
        <AlertDialogAction variant={confirmVariant} onClick={onConfirm}>
          {confirmText}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  title: PropTypes.node,
  description: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmVariant: PropTypes.string,
  cancelVariant: PropTypes.string,
  icon: PropTypes.node,
  onConfirm: PropTypes.func,
};

export default ConfirmDialog;
